/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S2_I2_TextInputs */

const tr_kullanim_s2_i2_text = /** @type {(inputs: Kullanim_S2_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`çoklu pazaryeri yönetimi, e-Fatura entegrasyonu, mesajlaşma, AI otomasyonu, kargo`)
};

const en_kullanim_s2_i2_text = /** @type {(inputs: Kullanim_S2_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`multi-marketplace management, e-Fatura integration, messaging, AI automation, shipping`)
};

const de_kullanim_s2_i2_text = /** @type {(inputs: Kullanim_S2_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwaltung mehrerer Marktplätze, e-Fatura-Integration, Nachrichtenaustausch, AI-Automatisierung, Versand`)
};

const ru_kullanim_s2_i2_text = /** @type {(inputs: Kullanim_S2_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`управление несколькими маркетплейсами, интеграция e-Fatura, обмен сообщениями, AI-автоматизация, доставка`)
};

/**
* | output |
* | --- |
* | "multi-marketplace management, e-Fatura integration, messaging, AI automation, shipping" |
*
* @param {Kullanim_S2_I2_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s2_i2_text = /** @type {((inputs?: Kullanim_S2_I2_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S2_I2_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s2_i2_text(inputs)
	if (locale === "de") return de_kullanim_s2_i2_text(inputs)
	if (locale === "ru") return ru_kullanim_s2_i2_text(inputs)
	return tr_kullanim_s2_i2_text(inputs)
});